<template>
	<div class="myreward-information d-flex flex-wrap ga-5 justify-space-between">


		<div class="d-flex flex-column justify-space-between">
			<span class="myreward-information__title">Created</span>
			<span class="myreward-information__value">
				{{
					new Date(selectedMyPayoutData.created_at * 1000)
						.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
				}}
			</span>
		</div>


		<div class="d-flex flex-column justify-space-between">
			<span class="myreward-information__title">Email</span>
			<span class="myreward-information__value">
				{{ selectedMyPayoutData.email_input }}
			</span>
		</div>


		<div class="d-flex flex-column justify-space-between">
			<span class="myreward-information__title">Status</span>
			<span class="myreward-information__value" :class="stateClass">
				{{ selectedMyPayoutData.current_state.state_name }}
			</span>
		</div>


	</div>
</template>



<script setup>

import { computed } from "vue";
import { PayoutStore } from "@/store/PayoutStore";
  
const payoutStore = PayoutStore();
const selectedMyPayoutData = computed(() => {
	return payoutStore.SelectedMyPayoutData;
});

const stateClass = computed(() => {
	const stateName = selectedMyPayoutData.value.current_state.state_name.toLowerCase();
	return `myreward-information__state--${stateName}`;
});

</script>